// src/helpers.ts
function sortByStart(a, b) {
  return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
}
function sortByEnd(a, b) {
  return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
}
function hasOverlap(a, b) {
  return b[1] > a[0] && b[0] < a[1];
}

// src/union.ts
function union(...intervals) {
  if (!intervals.length) {
    return [];
  }
  intervals = intervals.sort(sortByStart);
  const result = [];
  let [start, end] = intervals[0];
  for (let i = 1, n = intervals.length; i < n; i++) {
    const [nextStart, nextEnd] = intervals[i];
    if (end < nextStart) {
      result.push([start, end]);
      start = nextStart;
    }
    if (end < nextEnd) {
      end = nextEnd;
    }
  }
  return [...result, [start, end]];
}
function arrayUnion(...arrays) {
  if (!arrays.length) {
    return [];
  }
  let flattenedIntervals = [];
  for (let i = 0, n = arrays.length; i < n; i++) {
    flattenedIntervals = flattenedIntervals.concat(arrays[i]);
  }
  return union(...flattenedIntervals);
}

// src/difference.ts
function difference(a, b) {
  if (!hasOverlap(a, b)) {
    return [a];
  }
  if (b[0] > a[0] && b[1] < a[1]) {
    return [
      [a[0], b[0]],
      [b[1], a[1]]
    ];
  }
  if (b[0] <= a[0] && b[1] >= a[1]) {
    return null;
  }
  return b[0] > a[0] ? [[a[0], b[0]]] : [[b[1], a[1]]];
}
function arrayDifference(inputIntervals, inputDiffIntervals) {
  const intervals = union(...inputIntervals);
  const diffIntervals = union(...inputDiffIntervals);
  if (!intervals.length) {
    return [];
  }
  if (!diffIntervals.length) {
    return intervals;
  }
  const result = [];
  for (let i = 0, n = intervals.length; i < n; i++) {
    let [start, end] = intervals[i];
    let addInterval = true;
    for (let j = 0, m = diffIntervals.length; j < m; j++) {
      const diffInterval = diffIntervals[j];
      if (diffInterval[1] <= start) {
        continue;
      }
      if (diffInterval[0] >= end) {
        break;
      }
      const diff = difference([start, end], diffInterval);
      if (diff) {
        [start, end] = diff[diff.length - 1];
        if (diff.length > 1) {
          result.push(diff[0]);
        }
      } else {
        addInterval = false;
        break;
      }
    }
    if (addInterval) {
      result.push([start, end]);
    }
  }
  return result;
}

// src/intersection.ts
function intersection(...intervals) {
  intervals.sort(sortByStart);
  const [start, end] = [
    intervals[intervals.length - 1][0],
    intervals.sort(sortByEnd)[0][1]
  ];
  for (let i = 0, n = intervals.length; i < n - 1; i++) {
    const [nextStart, nextEnd] = intervals[i + 1];
    if (nextStart > end || nextEnd < start) {
      return null;
    }
  }
  return [start, end];
}
function arrayIntersection(...arrays) {
  let result = arrays[0];
  for (let i = 1, n = arrays.length; i < n; i++) {
    const array = arrays[i];
    array.sort(sortByStart);
    const tempResult = [];
    for (let j = 0, m = result.length; j < m; j++) {
      const resultInterval = result[j];
      for (let k = 0, l = array.length; k < l; k++) {
        const interval = array[k];
        if (interval[1] <= resultInterval[0]) {
          continue;
        }
        if (interval[0] >= resultInterval[1]) {
          break;
        }
        const isect = intersection(resultInterval, interval);
        if (isect) {
          tempResult.push(isect);
        }
      }
    }
    result = tempResult;
  }
  return result.length ? result : [];
}

// src/contains.ts
function contains(outerInterval, innerInterval) {
  return innerInterval[0] >= outerInterval[0] && innerInterval[1] <= outerInterval[1];
}
function arrayContains(outerIntervals, innerIntervals) {
  outerIntervals = arrayUnion(outerIntervals);
  innerIntervals = arrayUnion(innerIntervals);
  for (let i = 0, n = innerIntervals.length; i < n; i++) {
    const inner = innerIntervals[i];
    let isContained = false;
    for (let j = 0, m = outerIntervals.length; j < m; j++) {
      const outer = outerIntervals[j];
      if (contains(outer, inner)) {
        isContained = true;
        break;
      }
    }
    if (!isContained) {
      return false;
    }
  }
  return true;
}
export {
  arrayContains,
  arrayDifference,
  arrayIntersection,
  arrayUnion,
  contains,
  difference,
  intersection,
  union
};
